import { Inject, Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore, Sentry, SentryDesktop, SentryMobile } from "@obg/core.config";

import { ConfigService } from "../config/config.service";
import { EnvironmentContext } from "../config/environment/environment.model";
import { GLOBAL_CONFIG } from "../const";
import { DeviceType } from "../device/device.model";
import { GlobalConfig } from "../model";

/**
 * This strange piece of logic is left here in scope AC-43 intentionally.
 * Because currently halo and nazgul using same core config to bootstrap the sentry.
 * When halo and nazgul will have thier dedicated configs, this can be removed
 */
@Injectable({
	providedIn: "root",
})
export class LoggingConfigService {
	environmentContext: EnvironmentContext;

	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCore>,
		@Inject(GLOBAL_CONFIG) globalConfig: GlobalConfig
	) {
		this.environmentContext = globalConfig.environmentContext;
	}

	isProdMode(): boolean {
		return !this.environmentContext.isDebug;
	}

	getSentryUrl(): string {
		return this.getDeviceConfig().url;
	}

	getSentryEnabled(): boolean {
		return this.getDeviceConfig().enabled;
	}

	getVersion(): string {
		return this.environmentContext.version;
	}

	getEnvironment(): string {
		return this.environmentContext.environment;
	}

	getIgnoredErrors(): string[] {
		return [
			"gamingRouteService::getRouteNameByProduct",
			"documentMetaService::mapPageToDocumentMetaData",
			"E_BETTING_ODDS_INVALID",
			"E_SPORTSBOOK_INVALIDIDENTITY",
			"E_SPORTSBOOK_STREAMING_EVENTNOTFOUND",
			"E_SPORTSBOOK_GAMES_GAMEPLAYNOTALLOWEDFORCUSTOMER",
			"E_BETTING_FUNDS_INSUFFICIENT",
			"E_SINGLESIGNONSESSIONS_SITECORECOOKIENOTINHEADER",
			"E_AFFILIATE_INVALID_FROM",
			"E_AFFILIATE_MISSINGDATA",
			"E_INVALIDSESSIONTOKEN",
			"E_CAMPAIGNS_ENROLLMENTS_ALREADYENROLLED",
			"E_VALIDATION_PERSONALNUMBERINVALIDDATE",
			"E_VALIDATION_PERSONALNUMBERINVALIDCHECKSUM",
			"getLocalizedSegment",
			"Diffusion stream failed - Session is closed",
			"Failed publishing message - The connection handshake was rejected...",
			"Session Closed - The session was closed by the client",
			"obgRouteLink requires either 'route' or 'url'",
			"obgRouteLink input is not specified",
			"[uiInteractionTelemetryEffect::uiInteractionTracking$] Mapping not found",
			"ResizeObserver loop limit exceeded",
			"Server is now running on",
			"ResizeObserver loop completed with undelivered notifications.",
		];
	}

	private getDeviceConfig(): Sentry | SentryDesktop | SentryMobile {
		const genericConfig = this.configService.get((config) => config.global.logging.sentry!);

		// get device-specific settings if available
		const deviceConfig =
			this.environmentContext.deviceType === DeviceType.Desktop ? genericConfig.desktop : genericConfig.mobile;

		// return device-specific settings or fall back to generic settings
		return deviceConfig || genericConfig;
	}
}
